import { PartnerState } from './Interfaces/PartnerState';

const partnerInitialState: PartnerState = {
    partnerData: null,
    teamsForTeamSelector: null,
    updateTeam: {
        teamNameByDefault: '',
        teamLeaderByDefault: '',
    },
    selectedTeamsId: JSON.parse(window.localStorage.getItem('selectedTeamIds')) || [],
};

export default partnerInitialState;
